
export const clientExcelDataFormatter = ((client) => [
  client.fullName,
  client.phone,
  !client.address?.cityName ? 'Отсутствует' : client.address?.cityName,
  !client?.address?.address ? 'Отсутствует' : client?.address?.address,
  !client?.password ? 'Не установлено' : 'Установлено',
])